
export const SemiHeartMask = ({ headerImages, imgStyling }) => {
	const image = headerImages?.[0];
	if (!image) return null;

	return (
		<div className="relative w-full lg:w-1/2">
			<div className="hidden lg:block absolute top-[-300px] left-[-410px] w-[729px] h-[1200px] overflow-hidden rounded-[2000px] rotate-[45deg]">
				<div className="w-full h-full -rotate-[45deg] scale-[1.5] translate-x-[-10%] translate-y-[-20%]">
					<img
						src={image.imageUrl}
						alt={image.alt}
						fetchpriority="high"
						className={`w-full h-full object-contain object-center ${imgStyling || ""}`}
						/>
				</div>
			</div>
		</div>
	);
};
